// Meter Readings API Client
class MeterReadingsApi {
  constructor() {
    this.baseUrl = window.location.origin;
    this.token = JSON.parse(localStorage.getItem('auth'))?.token;
  }

  async getReadings(propertyId, meterId = null, domainId) {
    try {
      const params = new URLSearchParams({
        propertyId: propertyId.toString(),
        domainId: domainId.toString()
      });
      
      if (meterId) {
        params.append('meterId', meterId);
      }

      const response = await fetch(`${this.baseUrl}/api/meter-readings?${params}`, {
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching meter readings:', error);
      throw error;
    }
  }

  async createReading(readingData) {
    try {
      const response = await fetch(`${this.baseUrl}/api/meter-readings`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(readingData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating meter reading:', error);
      throw error;
    }
  }

  async updateReading(readingId, readingData) {
    try {
      const response = await fetch(`${this.baseUrl}/api/meter-readings/${readingId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(readingData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating meter reading:', error);
      throw error;
    }
  }

  async deleteReading(readingId) {
    try {
      const response = await fetch(`${this.baseUrl}/api/meter-readings/${readingId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting meter reading:', error);
      throw error;
    }
  }
}

// Export as global function for use in client injects
window.MeterReadingsApi = MeterReadingsApi; 